export default __webpack_public_path__ + "static/media/fox.09c07381.png";